import { useTheme } from 'contexts/ThemeContext';
import React, { useEffect } from 'react';
import { Image, TouchableOpacity, } from 'react-native';
import styleSheet from './styles'

export interface HeaderBackButtonProps {
    onPress: () => void;
}

const HeaderBackButton = (props: HeaderBackButtonProps) => {
    const theme = useTheme()
    const styles = styleSheet(theme);

    return (
        <TouchableOpacity
            hitSlop={{ top: 10, left: 10, right: 10, bottom: 10 }}
            style={styles.container}
            onPress={props.onPress}>
            <Image source={theme.images.back} />
        </TouchableOpacity>
    )
};

export default HeaderBackButton;
